import $ from 'jquery';

const $width = window.innerWidth;
const $height = window.innerHeight;
let url = location.pathname;
if($width > 980){
  if(url === '/'){
    let dif = $('.border_fire').height();
    let $border_top1 = $('.p-topToSpa').offset().top - $height + 40;
    let $border_top2 = $('.border_fire').offset().top - $height + dif;
    let $border_top3 = $('.border_fire3').offset().top - $height + dif;

    $(window).on('scroll', function() {
      if ($(this).scrollTop() > $border_top1) {
        $('.border_top1').addClass('scrolled_top1');
      }
      if ($(this).scrollTop() > $border_top2) {
        $('.border_top2').addClass('scrolled_top2');
      }
      if ($(this).scrollTop() > $border_top3) {
        $('.border_top3').addClass('scrolled_top3');
      }
    });
  }
}else if($width <= 980 && $width > 750){
  if(url === '/'){
    let dif = $('.border_fire').height();
    let $border_top1 = $('.p-topToSpa').offset().top - $height + 40;
    let $border_top2 = $('.border_fire').offset().top - $height + dif;
    let $border_top3 = $('.border_fire3').offset().top - $height + dif;

    $(window).on('scroll', function() {
      if ($(this).scrollTop() > $border_top1) {
        $('.border_top1').addClass('scrolled_top1');
      }
      if ($(this).scrollTop() > $border_top2) {
        $('.border_top2').addClass('scrolled_top2');
      }
      if ($(this).scrollTop() > $border_top3) {
        $('.border_top3').addClass('scrolled_top3');
      }
    });
  }
};

if($width > 750){
  if(url === '/sales/'){
    let $border_sales = $('.border_fire').offset().top -$height + 55;
    $(window).on('scroll',  function() {
      if($(this).scrollTop() > $border_sales) {
        $('.border_sales').addClass('scrolled_sales');
      }
    });
  }else if(url === '/spa/'){
    let dif = $('.border_fire1').height();
    let $border_spa1 = $('.border_fire1').offset().top - $height + dif/2;
    let $border_spa2 = $('.border_fire2').offset().top - $height + dif/2;
    $(window).on('scroll', function(){
      if($(this).scrollTop() > $border_spa1) {
        $('.border_spa1').addClass('scrolled_spa1');
      }
      if($(this).scrollTop() > $border_spa2) {
        $('.border_spa2').addClass('scrolled_spa2');
      }
    });
  }else if(url === '/contact/index.php') {
    let $border_contact1 = $('.border_fire1').offset().top - $height;
    let $border_contact2 = $('.border_fire2').offset().top - $height;

    $(window).on('scroll', function(){
      if($(this).scrollTop() > $border_contact1) {
        $('.border_contact1').addClass('scrolled_contact1');
      }
      if($(this).scrollTop() > $border_contact2) {
        $('.border_contact2').addClass('scrolled_contact2');
      }
    });
  }else if(url === '/facility/'){
    let $border_facility1 = $('.border_fire1').offset().top - $height - 50;
    let $border_facility2 = $('.border_fire1').offset().top + 250;

    $(window).on('scroll', function() {
      if($(this).scrollTop() > $border_facility1) {
        $('.border_facility1').addClass('scrolled_facility1');
      }
      if($(this).scrollTop() > $border_facility2) {
        $('.border_facility2').addClass('scrolled_facility2');
      }
    })
  }else if(url === '/contact/done.html'){
    let $border_done = $('.border_fire').offset().top - $height + 25;

    $(window).on('scroll',  function() {
      if($(this).scrollTop() > $border_done) {
        $('.border_done').addClass('scrolled_done');
      }
    });
  }
}


// WEBPACK FOOTER //
// ./dev/js/bgi_anime.js